import { useState } from 'react';

import type { ErrorLike } from '@apollo/client';
import { useMutation } from '@apollo/client/react';
import { Button } from '@mui/material';

import { MutationErrorSnackbar } from '@modules/_shared/components/MutationErrorModal';
import { useAppData } from '@modules/_shared/providers/AppDataProvider';
import type { TransactionFormData } from '@modules/transactions/TransactionFormDefinition';
import {
  GET_PROPERTY_TRANSACTIONS,
  TRANSACTION_FORM_QUERY,
  UPDATE_TRANSACTION_REVIEWED_AT,
} from '@modules/transactions/transactionQueries';
import { useLocale } from '@shared/hooks/locale';

export const ReviewTransactionButton = ({
  transactionId,
}: {
  transactionId: TransactionFormData['id'];
}) => {
  const { me } = useAppData();
  const [apolloError, setErrorLike] = useState<ErrorLike | null>(null);
  const { t } = useLocale();
  const [updateTransactionReviewedAt, { loading }] = useMutation(
    UPDATE_TRANSACTION_REVIEWED_AT,
    {
      refetchQueries: [
        { query: TRANSACTION_FORM_QUERY, variables: { id: transactionId } },
        GET_PROPERTY_TRANSACTIONS,
      ],
      awaitRefetchQueries: true,
      onError: setErrorLike,
    },
  );
  return (
    <>
      <Button
        variant="contained"
        loadingPosition="start"
        loading={loading}
        disabled={me?.id == null || transactionId == null}
        onClick={async () => {
          if (me?.id == null || transactionId == null) {
            return;
          }
          updateTransactionReviewedAt({
            variables: {
              id: transactionId,
              reviewed_at: new Date().toISOString(),
              reviewed_by: me.id,
            },
          });
        }}
      >
        {t('Mark as approved')}
      </Button>
      <MutationErrorSnackbar
        error={apolloError}
        onClose={() => setErrorLike(null)}
      />
    </>
  );
};
